const packageJson = require('../../package.json');

export const environment = {
  appName: 'Track & Trace',
  envName: 'prod',
  base_config: 'config.prod.json',
  secret_token_key: 'W#0@2eY0u2$ecret%',
  allow_host: [
    'https://th.kex-express.com',
    'http://th.kex-express.com',
    'https://poc-track.th.kex-express.com',
    'poc-it.th.kex-express.com',
     
    'https://th.kerryexpress.com',
    'http://th.kerryexpress.com',
    'https://poc-track.th.kerryexpress.com',
    'poc-it.th.kerryexpress.com',
  ],
  server_app_path:'/track',
  production: true,
  test: false,
  i18nPrefix: '',
  versions: {
    app: packageJson.version,
    angular: packageJson.dependencies['@angular/core'],
    material: packageJson.dependencies['@angular/material'],
    rxjs: packageJson.dependencies.rxjs,
    ngxtranslate: packageJson.dependencies['@ngx-translate/core'],
    fontAwesome: packageJson.dependencies['@fortawesome/fontawesome-free'],
    angularCli: packageJson.devDependencies['@angular/cli'],
    typescript: packageJson.devDependencies['typescript'],
  },
};
